import { PlannerProfileListSearchCriteria } from '../../../../models';

export class TransportManagementProfileListLoad {
  public static readonly type = '[TransportManagementProfileList] Load';
  constructor(public payload: PlannerProfileListSearchCriteria) {}
}

export class TransportManagementProfileListInitialState {
  public static readonly type = '[TransportManagementProfileList] Set Initial State';
}
